import { IntersectionData } from './intersectionData.model';
import { QueueCharacteristics } from './queueCharacteristics.model';

export class SiterecordCharacteristicsExtended {
  public id: number;
  public siterecordCharacteristicsId: number;
  public timeToForecastPeriodStart?: number;
  public queueCharacteristics?: QueueCharacteristics[];
  public intersectionData?: IntersectionData[];
}



// WEBPACK FOOTER //
// ./src/app/models/siterecordcharacteristicsextended.model.ts